import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { FormsModule } from '@angular/forms';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { NgClass } from '@angular/common';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { SelectComponent } from '../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-noticias',
    templateUrl: './noticias.component.html',
    styleUrls: ['./noticias.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, FormsModule, BreadcrumbComponent, NgClass, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, SelectComponent, NgxPaginationModule, FooterComponent, AppDatePipe]
})
export class NoticiasComponent implements OnInit {

  public noticias: any = null;
  // ITENS DA PAGINAÇÃO INICIO
  public paginaNoticia: number = 0;
  public noticiasPorPagina: string = '6';
  // ITENS DA PAGINAÇÃO FIM
  private idEmpresaLogada: string;
  public dataFiltrada: any = '';

  // Variáveis para BOTÕES de FILTROS
  public inputBusca: string = '';
  public inputFiltrado: boolean = false;
  public semFiltro: boolean = true;
  public filtroReajuste: string = '';
  public filtrarData: boolean = false;
  public filtroMigracao: string = '';

  constructor(private readonly service: NoticiasService, public router: Router) { }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;

    if (sessionStorage.noticiaInputBuscaFiltro) {

      this.inputBusca = sessionStorage.noticiaInputBuscaFiltro;
      this.inputFiltrado = true;
      this.getAllNoticias();

    } else {
      this.getAllNoticias();
    }
  }

  getAllNoticias() {

    sessionStorage.removeItem('noticiaInputBuscaFiltro');
    this.noticias = null;

    this.service.getAllNoticias(this.idEmpresaLogada, this.dataFiltrada, this.filtroReajuste, this.filtroMigracao, this.inputBusca)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.noticias = response.response;
          } else {
            this.noticias = undefined;
          }
        },
        error: (erro: any) => {
          this.noticias = false;
          console.error(erro);
        }
      });
  }

  buscaNoticiaConteudo() {
    this.filtroReajuste = '';
    this.filtroMigracao = '';
    this.filtrarData = false;
    this.dataFiltrada = '';
    this.semFiltro = false;

    if (this.inputBusca) {
      this.inputFiltrado = true;
      this.noticias = null;
      this.getAllNoticias();
    }
  }

  detalharNoticias(idNoticia: number) {
    this.router.navigate(["noticias-detalhes"], { queryParams: { idNoticia: idNoticia } });
  }

  filtrarReajuste() {
    this.inputBusca = '';
    this.inputFiltrado = false;
    this.semFiltro = false;
    this.filtrarData = false;
    this.dataFiltrada = '';
    this.filtroMigracao = '';
    this.filtroReajuste = 'Reajuste';
    this.noticias = null;
    this.getAllNoticias();
  }

  filtrarMigracao() {
    this.inputBusca = '';
    this.inputFiltrado = false;
    this.semFiltro = false;
    this.filtroReajuste = '';
    this.filtrarData = false;
    this.dataFiltrada = '';
    this.filtroMigracao = 'Migra';

    this.noticias = null;
    this.getAllNoticias();
  }

  filtrarPorData() {
    this.inputBusca = '';
    this.inputFiltrado = false;
    this.semFiltro = false;
    this.filtroReajuste = '';
    this.filtroMigracao = '';
    this.paginaNoticia = 0;

    this.noticias = null;
    this.dataFiltrada = this.dataFiltrada.toLocaleDateString("en-US");

    this.getAllNoticias();
  }

  removerTodosFiltros() {

    // CASO SEJA TRUE, QUER DIZER QUE JÁ ESTÁ SEM FILTRO, NÃO TEM O QUE MUDAR, OU SEJA NÃO CONSULTA DE NOVO
    if (this.semFiltro === false) {
      this.inputBusca = '';
      this.inputFiltrado = false;
      this.filtroReajuste = '';
      this.filtroMigracao = '';
      this.filtrarData = false;
      this.dataFiltrada = '';
      this.semFiltro = true;

      this.noticias = null;
      this.getAllNoticias();
    } else {
      this.inputBusca = '';
      this.inputFiltrado = false;
      this.dataFiltrada = '';
      this.filtrarData = false;
      this.noticias = null;
      this.getAllNoticias();
    }

  }

}
